// src/components/PageNavbarDesktop/PageNavbarDesktop.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './PageNavbarDesktop.css';
import logo from '../../../images/logo.webp';
import Submenu from './Submenu';
import Modal from '../../Modal/Modal';
import Cotizador from '../../Cotizador/Cotizador';
import TagManager from 'react-gtm-module';

const PageNavbarDesktop = () => {
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const submenuTimeoutRef = useRef(null);
  const [isNavbarTransparent, setIsNavbarTransparent] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [cotizadorOpen, setCotizadorOpen] = useState(false);

  const openCotizador = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'navbar_solicitar_cotizacion',
          event_category: 'engagement',
          event_label: 'Solicitud de Cotización - Navbar',
          value: null,
          slug: null
        }
      });
    }
    setCotizadorOpen(true);
  };

  const closeCotizador = () => setCotizadorOpen(false);

  // Control de transparencia según ruta y scroll
  useEffect(() => {
    setIsNavbarTransparent(location.pathname === '/');
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0 && !hasScrolled) {
        setHasScrolled(true);
        setIsNavbarTransparent(false);
        window.removeEventListener('scroll', handleScroll);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolled]);

  // Handlers de hover para submenu
  const handleMouseEnter = () => {
    clearTimeout(submenuTimeoutRef.current);
    setSubmenuOpen(true);
  };
  const handleMouseLeave = () => {
    submenuTimeoutRef.current = setTimeout(() => setSubmenuOpen(false), 200);
  };

  const handleNavbarMouseEnter = () => setIsNavbarTransparent(false);
  const handleNavbarMouseLeave = () => {
    if (!hasScrolled && location.pathname === '/') {
      setIsNavbarTransparent(true);
    }
  };

  // Nuevo handler para cerrar submenu al click
  const handleProductosClick = () => {
    setSubmenuOpen(false);
    navigate('/productos');
  };

  return (
    <>
      <nav className={`page-navbar ${isNavbarTransparent ? 'page-navbar-transparent' : ''}`}>
        <div className="page-navbar-content">
          <div className="page-navbar-logo">
            <Link to="/"><img src={logo} alt="Logo" /></Link>
          </div>
          <div className="page-navbar-links-desktop">
            <div onMouseEnter={handleNavbarMouseEnter} onMouseLeave={handleNavbarMouseLeave}>
              <Link to="/">INICIO</Link>
            </div>
            <div
              className="navbar-productos-container"
              onMouseEnter={() => { handleMouseEnter(); handleNavbarMouseEnter(); }}
              onMouseLeave={() => { handleMouseLeave(); handleNavbarMouseLeave(); }}
            >
              <Link to="/productos" onClick={() => setSubmenuOpen(false)}>PRODUCTOS</Link>

              {submenuOpen && <Submenu onClose={() => setSubmenuOpen(false)} />}
            </div>
            <div onMouseEnter={handleNavbarMouseEnter} onMouseLeave={handleNavbarMouseLeave}>
              <Link to="/servicios">SERVICIOS</Link>
            </div>
            <div onMouseEnter={handleNavbarMouseEnter} onMouseLeave={handleNavbarMouseLeave}>
              <Link to="/noticias">NOTICIAS</Link>
            </div>
            <div onMouseEnter={handleNavbarMouseEnter} onMouseLeave={handleNavbarMouseLeave}>
              <Link to="/contacto">CONTACTO</Link>
            </div>
            <div
              className="navbar-desktop-campana"
              onMouseEnter={handleNavbarMouseEnter}
              onMouseLeave={handleNavbarMouseLeave}
              onClick={openCotizador}
            >
              COTIZAR
            </div>
          </div>
        </div>
      </nav>

      {/* Cotizador Modal */}
      <Modal isOpen={cotizadorOpen} onClose={closeCotizador}>
        <Cotizador onClose={closeCotizador} />
      </Modal>
    </>
  );
};

export default PageNavbarDesktop;
